<p-iconfield [ngClass]="widthClass()">
  <p-inputicon><i class="pi pi-search"></i></p-inputicon>
  <input
    #input
    pInputText
    type="text"
    class="w-full"
    [attr.data-testid]="testId() || null"
    [value]="value()"
    (input)="onInput(input.value)"
    (keydown.escape)="clear()"
    placeholder="{{ placeholderKey() | transloco }}..."
  />
  @if (value()) {
    <p-inputicon class="cursor-pointer" (click)="clear()"><i class="pi pi-times"></i></p-inputicon>
  }
</p-iconfield>
